module.exports = __webpack_public_path__ + "static/media/wallet.28db9c65.svg";